import {
  FAILURE,
  RESET,
  RELOADING,
  FIELDPENDING,
  FIELDSUCCESS,
  USERFIELDPENDING,
  USERFIELDSUCCESS,
  AUTOFIELDPENDING,
  AUTOFIELDSUCCESS,
  AUTOFIELDVALUEPENDING,
  AUTOFIELDVALUESUCCESS,
  FILTERFIELDPENDING,
  FILTERFIELDSUCCESS,
  SEARCHFILTERFIELDPENDING,
  SEARCHFILTERFIELDSUCCESS,
} from '../../constants'
import {
  getEntity as getEntityAPI,
  getEntityFilterFields as getEntityFilterFieldsAPI,
  getEntityUserUpdateFields as getEntityUserUpdateFieldsAPI,
  getEntityAutoUpdateFields as getEntityAutoUpdateFieldsAPI,
  getEntityAutoUpdateFieldsValues as getEntityAutoUpdateFieldsValuesAPI,
  getSearchUsers as getSearchUsersAPI,
  getEntitySearchFilterFields as getEntitySearchFilterFieldsAPI,
} from '../../../services/entities'

export async function getEntity(id, dispatch) {
  dispatch({type: FIELDPENDING})
  try {
    const response = await getEntityAPI(id)
    let responseObj = {
      id: id,
      fields: response,
    }
    dispatch({type: FIELDSUCCESS, payload: responseObj})
  } catch (e) {
    console.log(`Get Entity Failed: ${id}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function getEntityUserFieldData(id, dispatch) {
  dispatch({type: USERFIELDPENDING})
  try {
    const response = await getEntityUserUpdateFieldsAPI(id)
    dispatch({type: USERFIELDSUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entity Failed: ${id}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function getEntityAutoFieldData(id, dispatch) {
  dispatch({type: AUTOFIELDPENDING})
  try {
    const response = await getEntityAutoUpdateFieldsAPI(id)
    dispatch({type: AUTOFIELDSUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entity Failed: ${id}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function getEntityAutoUpdateFieldsValuesData(id, fieldId, dispatch) {
  dispatch({type: AUTOFIELDVALUEPENDING})
  try {
    const response = await getEntityAutoUpdateFieldsValuesAPI(id, fieldId)
    dispatch({type: AUTOFIELDVALUESUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entity Failed value: ${id}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function getEntityFilterFieldData(id, filter, dispatch) {
  dispatch({type: FILTERFIELDPENDING})
  try {
    const response = await getEntityFilterFieldsAPI(id)
    dispatch({type: FILTERFIELDSUCCESS, payload: response, filter: filter})
  } catch (e) {
    console.log(`Get Entity Failed: ${id}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function setEntityReloading(dispatch) {
  try {
    dispatch({type: RELOADING})
  } catch (e) {
    console.log(`Reset Entity Failed`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function setEntity(dispatch) {
  try {
    dispatch({type: RESET})
  } catch (e) {
    console.log(`Reset Entity Failed`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function getEntitySearchFilterFieldData(id, search, dispatch) {
  dispatch({type: SEARCHFILTERFIELDPENDING})
  try {
    const response = await getEntitySearchFilterFieldsAPI(id, search)
    dispatch({type: SEARCHFILTERFIELDSUCCESS, payload: response})
    return true
  } catch (e) {
    console.log(`Get Entity Failed: ${id}`)
    dispatch({type: FAILURE, payload: e})
    return true
  }
}
